/**
 * Add date range parameters to an object if dates are provided
 * @param params - The object to add date parameters to
 * @param startDate - The start date (optional)
 * @param endDate - The end date (optional)
 */
export const addDateRangeParams = (
  params: Record<string, any>,
  startDate: Date | null,
  endDate: Date | null
): void => {
  if (startDate) {
    params.startDate = startDate.toISOString().split('T')[0];
  }
  
  if (endDate) {
    params.endDate = endDate.toISOString().split('T')[0];
  }
};
